<template>
  <div style="overflow:auto;height:90vh">
    <ul>
      <!--产品列表-->
      <li
        v-for="(product,index) in products"
        :key="product.id"
        :class="['productitem', {'productitemon':index==hoverIndex}]"
        @mouseover="hoverIndex = index"
        @mouseout="hoverIndex = -1"
      >
        <div class="removeP" v-show="index==hoverIndex">
          <span style="float:left">
            <i class="el-icon-close" title="删除" @click="removeProduct(product.id)"></i>
          </span>
          <span style="float:right">
            <i class="el-icon-document" title="目录内容" @click="productContent(product.id)"></i>
          </span>
        </div>
        <div @click="editProduct(product.id)">
          <el-container>
            <el-main>
              <el-image class="productitemimg" :src="product.image" fit="cover"></el-image>
            </el-main>
            <el-footer class="producttitle" height="40px">{{ product.name }}</el-footer>
          </el-container>
        </div>
      </li>
      <li
        :class="['productitem', {'productitemon':-2==hoverIndex}]"
        @click="addProduct()"
        @mouseover="hoverIndex = -2"
        @mouseout="hoverIndex = -1"
      >
        <el-container>
          <el-main>
            <i class="el-icon-plus" style="font-size:100px;margin: 10px 0;"></i>
          </el-main>
          <el-footer class="producttitle" height="40px">添加产品</el-footer>
        </el-container>
      </li>
    </ul>
  </div>
</template>
<script>
import config from "../../../api/config";
import { getList, delProduct } from "../../../api/gm/api-product";
export default {
  data() {
    return {
      staticURL: config.staticURL, //图片域名
      hoverIndex: -1, //判断选中状态
      products: null
    };
  },
  created() {
    getList().then(res => {
      if (res.code === 0) {
        this.products = res.data;
        this.products.forEach(i => {
          i.image = this.staticURL + i.image;
        });
      } else {
        console.log(res.msg);
      }
    });
  },
  methods: {
    productContent(pid) {
      this.$router.push({ path: "/gm/product/content/" + pid });
    },
    addProduct() {
      this.$router.push({ path: "/gm/product/add" });
    },
    editProduct(pid) {
      this.$router.push({ path: "/gm/product/edit/" + pid });
    },
    removeProduct(pid) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        lockScroll: false
      })
        .then(() => {
          delProduct(pid).then(res => {
            if (res.code === 0) {
              this.$message({
                message: "产品已加入回收站",
                type: "success",
                onClose: this.$router.go(0)
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.productitem {
  width: 20%;
  margin: 10px 5%;
  float: left;
  list-style: none;
  text-align: center;
  cursor: pointer;
  border: 1px solid #e7e6e6;
  position: relative;
}
.productitemon {
  border: 1px solid #1f8fff;
  color: #1f8fff;
}

.productitemimg {
  margin: 10px 0;
  width: 100px;
  height: 100px;
}
.producttitle {
  font-size: 12px;
  padding: 5px;
}
.removeP {
  margin: 5px 5px 0 5px;
  position: absolute;
  width:95%;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/product/index.vue